import React, { ReactElement } from 'react';
import { CreatJobProgressStatus } from './CreateJobHeader';
import { useSelector } from 'react-redux';
import { getCreateJobNameFromAppState } from '../../store/selectors/createJobSelectors';
import { AppState } from '../../store/state/appState';
import JobPageContainer from './JobPageContainer';

export default function CreateJobStep(props: Props) {
	const name = useSelector<AppState, string>(s => getCreateJobNameFromAppState(s, props.engagementId));
	
	return (
		<React.Fragment>
			<JobPageContainer engagementId={props.engagementId} jobName={name} progressStatus={props.progressStatus}>
				{props.children}
			</JobPageContainer>
		</React.Fragment>
	);
}

interface Props {
	engagementId: number;
	progressStatus: CreatJobProgressStatus;
	children: ReactElement;
}
